import {
  INTERNET_CONNECTION_AVAILABLE,
  WEON_CONNECTION_AVAILABLE,
  RECONNECTION_CONFIRMATION,
  CONNECTION_PROBLEM_DIALOG,
  CONNECTION_PROBLEM_WEBRTC,
  CONNECTION_WEBRTC_STATUS,
  CONNECTION_WEBRTC_DEVICE_CONNECTION_LOST,
} from '@/store/mutation-types';

const actions = {
  setInternetConnectionAvailable({ commit }, isConnectedToInternet) {
    commit(INTERNET_CONNECTION_AVAILABLE, isConnectedToInternet);
  },
  setWeonConnectionAvailable({ commit }, isConnectedToWeon) {
    commit(WEON_CONNECTION_AVAILABLE, isConnectedToWeon);
  },
  setReconnectionConfirmation({ commit }, isConfirmed) {
    commit(RECONNECTION_CONFIRMATION, isConfirmed);
  },
  showConnectionProblemDialog({ commit }, showDialog) {
    commit(CONNECTION_PROBLEM_DIALOG, showDialog);
  },
  lostWebRTCConnection({ commit }, status) {
    commit(CONNECTION_PROBLEM_WEBRTC, status);
  },
  setConnectionWebRTCStatus({ commit }, state) {
    commit(CONNECTION_WEBRTC_STATUS, state);
  },
  setLostDeviceConnectionDialog({ commit }, state) {
    commit(CONNECTION_WEBRTC_DEVICE_CONNECTION_LOST, state);
  },
};

export default actions;
